import * as constants from '../constants/constant';

import { Helper } from '@walmart-dataventures/integrated-components';

const { applicationOrigin } = Helper.getCurrentApplicationHostInfo();
export const getAPIURL = () => {
	return applicationOrigin;
};

export const getCurrentEnv = () => {
	const { host } = window.location;
	const env = 'prod';
	if (host.includes('localhost')) {
		return 'local';
	} else if (host.includes('dev.')) {
		return 'dev';
	} else if (host.includes('qa.')) {
		return 'qa';
	} else if (host.includes('stg.')) {
		return 'stg';
	}
	return env;
};

export const getAdobeScriptURL = () => {
	if (getCurrentEnv() === 'prod') {
		return constants.ADOBE_URL['prod'];
	} else {
		return constants.ADOBE_URL['non-prod'];
	}
};

export const getStoreDrillDownPayload = ({
	selectedFilters = { startDate: '', endDate: '', weekFilter: '' }, // Default to empty strings if not provided
	id,
	name,
	threshold,
	itemId,
	weekSelectedFilter,
}) => {
	const period = WEEK_DURATION_TYPE[`${weekSelectedFilter}`];
	return {
		request: {
			startDate: selectedFilters.startDate,
			endDate: selectedFilters.endDate,
			id: [id],
			name: name,
			channel: ['STORE'],
		},
		threshold,
		itemId,
		period,
	};
};

// Constants for Date filter type
const WEEK_DURATION_TYPE = {
	'-1': `CUSTOM`,
	0: `WTD`,
	1: `LW`,
	4: `L4W`,
	13: `L13W`,
	26: `L26W`,
	52: `L52W`,
};
